import { Link } from "@tanstack/react-router";
import { ArrowRight, ClipboardCheck, Settings, MonitorCog, Wrench, Paintbrush } from "lucide-react";
import type { ServiceConfig } from "@/lib/site-config";

const iconMap: Record<string, React.ComponentType<{ className?: string }>> = {
  ClipboardCheck, Settings, MonitorCog, Wrench, Paintbrush,
};

export function ServiceCard({ service }: { service: ServiceConfig }) {
  const Icon = iconMap[service.icon] || Settings;

  return (
    <Link
      to={`/${service.slug}` as any}
      aria-label={`${service.name} — ${service.shortDesc}`}
      className="group relative flex flex-col rounded-2xl surface-premium surface-premium-hover p-6 md:p-7 overflow-hidden focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-background active:scale-[0.99] motion-reduce:active:scale-100 motion-reduce:transition-none"
    >
      {/* Top accent rule */}
      <span className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-primary/40 to-transparent opacity-0 group-hover:opacity-100 group-focus-visible:opacity-100 transition-opacity" />

      <div className="flex items-start justify-between">
        <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br from-primary/12 to-primary/4 border border-primary/15 text-primary group-hover:from-primary group-hover:to-primary group-hover:text-primary-foreground group-hover:border-primary group-focus-visible:from-primary group-focus-visible:to-primary group-focus-visible:text-primary-foreground transition-all duration-300 motion-reduce:transition-none">
          <Icon className="h-5 w-5" aria-hidden="true" />
        </div>
        <span className="text-[10px] font-bold tracking-[0.2em] uppercase text-muted-foreground">
          {String((service as any).number ?? "").padStart(2, "0") || ""}
        </span>
      </div>

      <h3 className="mt-5 text-lg font-bold text-foreground tracking-tight">{service.name}</h3>
      <p className="mt-2 text-sm text-muted-foreground leading-relaxed flex-1">{service.shortDesc}</p>

      <div className="mt-5 pt-4 border-t border-border/60 flex items-center justify-between">
        <span className="text-[13px] font-bold text-primary tracking-tight">Explore service</span>
        <ArrowRight className="h-4 w-4 text-primary transition-transform motion-safe:group-hover:translate-x-1 motion-safe:group-focus-visible:translate-x-1 motion-reduce:transition-none" aria-hidden="true" />
      </div>
    </Link>
  );
}

